import React from "react";
import { CircularProgress } from "@mui/material";
import { styled } from "@mui/system";

const LoaderContainer = styled("div")(({ show }) => ({
  display: show ? "flex" : "none",
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
  backgroundColor: "rgba(255, 255, 255, 0.7)", // semi-transparent background
}));

const CustomCircularP = ({ show }) => {
  return (
    <LoaderContainer show={show}>
      <CircularProgress color="primary" size={60} thickness={4} />
    </LoaderContainer>
  );
};

export default CustomCircularP;
